import { useContext, useEffect, useState } from "react";
import { getrevenuedetaill } from "./pipline&servicekpi";
import { FilterContext } from "../../context/Filter";

// Convert any number to Crores with up to 2 decimals
const formatNumberInCr = (num) => {
    if (!num && num !== 0) return "—";
    return `${(num / 10000000).toFixed(1)} Cr`;
};

export default function RevenueDetails() {
    const [revenuedata, setRevenuedata] = useState(null);
    const { arn: parArn, childArn } = useContext(FilterContext);

    const key = childArn ? "childArn" : "parArn";
    const value = childArn || parArn;
    const payload = { [key]: value };

    useEffect(() => {
        const fetchrevenuedetails = async () => {
            try {
                const res = await getrevenuedetaill(payload);
                if (res) setRevenuedata(res);
            } catch (error) {
                console.error("Error fetching revenue details:", error);
            }
        };
        if (value) fetchrevenuedetails();
    }, [value]);

    if (!revenuedata) {
        return (
            <div className="flex justify-center items-center h-screen">
                <p className="text-gray-500">Loading or no data yet...</p>
            </div>
        );
    }

    const cards = [
        {
            title: "Def Revenue",
            amount: formatNumberInCr(revenuedata.defRevenue),
            bgColor: "bg-blue-100",
            textColor: "text-blue-800",
        },
        {
            title: "Prolife Revenue",
            amount: formatNumberInCr(revenuedata.profile_revenue),
            bgColor: "bg-teal-100",
            textColor: "text-teal-800",
        },
        {
            title: "Lubs Revenue",
            amount: formatNumberInCr(revenuedata.lubsRevenue),
            bgColor: "bg-slate-100",
            textColor: "text-slate-800",
        },
        {
            title: "Spares Revenue Other",
            amount: formatNumberInCr(revenuedata.sparesOtherResult),
            bgColor: "bg-indigo-100",
            textColor: "text-indigo-800",
        },
    ];

    return (
        <div className="bg-gray-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-md p-3 max-w-3xl w-full">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                    {cards.map((item, index) => (
                        <div
                            key={index}
                            className={`${item.bgColor} ${item.textColor} p-3 flex flex-col items-center justify-center rounded-md min-h-[120px]`}
                        >
                            <h2 className="text-md font-semibold mb-1 text-center">
                                {item.title}
                            </h2>
                            <p className="text-lg font-bold">{item.amount}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
